/**
 * Default show stack info setting.
 */
export const DEFAULT_SHOW_CALL_STACK = false;
